import { notification } from 'antd'
import i18next from 'i18next'
import { action, makeObservable } from 'mobx'

import { IRootStore } from 'store/types'
import { BaseStore } from 'shared/stores/BaseStore'
import { PaginationType } from 'shared/types/types'

import { pvzApi } from '../../api'
import { PvzKeys } from '../../data'
import { Pvz } from './Pvz'

const getKey = (key: string) => `${PvzKeys.pvzModule}.api.${key}`

export class PvzStore extends BaseStore<Pvz> {
  constructor(private readonly rootStore: IRootStore) {
    super()
    makeObservable(this)
  }

  @action
  setPvzList = async (value: Pvz[]) => {
    this.putEntities(value)
  }

  @action
  async loadList(data: PaginationType = { page: 1, pageSize: 20 }) {
    try {
      this.setLoading(true)

      const res = await pvzApi.getPvzList({ page: data.page, pageSize: data.pageSize })
      const pvzList = res?.data?.map((x) => Pvz.create(x)) ?? []

      this.putEntities(pvzList)
      this.setTotalCount(res?.total)
    } catch (error) {
      notification.error({
        message: i18next.t(getKey('getPvzListError')),
        description: (error as Error).message,
      })
    } finally {
      this.setLoading(false)
    }
  }
}
